module.exports = __webpack_public_path__ + "media/images/icon_login_white-537176ed63bcd8692c4d7e36c00be864.png";